import { useEffect } from 'react';
import { redirectToAuth, checkAuthToken } from '@/utils/authUtils';
import { useNavigate } from 'react-router-dom';
import { isDevelopment } from '@/utils/environmentUtils';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already authenticated, redirect to dashboard
    if (checkAuthToken()) {
      navigate('/dashboard');
      return;
    }
    
    const hostname = window.location.hostname;

    console.log('Current hostname:', hostname);
    console.log('Is development environment:', isDevelopment());

    // Always redirect to auth provider (both dev and production)
    // The hardcoded token bypass is handled in the Callback component if needed
    console.log('Redirecting to auth provider');
    redirectToAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex items-center justify-center p-4">
      <div className="text-center">
        <p className="text-muted-foreground">Redirecting to sign in...</p>
      </div>
    </div>
  );
};

export default Login;
